import React, { useEffect, useRef } from 'react';
import { store } from '../../store';
import config from '../../config';

const buildHtml = (authToken, baseUrl) => `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Ops Analytics</title>
    <script src="https://cdn.jsdelivr.net/npm/chart.js"><\/script>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet">
    <style>
        :root { --bg:#fcfcfd;--panel:#fff;--sidebar:#fff;--border:#f2f4f7;--primary:#444ce7;--textMain:#101828;--textMuted:#667085;--accentBg:#f9f5ff; }
        *{box-sizing:border-box;-webkit-font-smoothing:antialiased;}
        body{margin:0;font-family:'Inter',sans-serif;background:var(--bg);display:flex;height:100vh;color:var(--textMain);}
        .sidebar{width:280px;background:var(--sidebar);border-right:1px solid var(--border);display:flex;flex-direction:column;}
        .sidebarHeader{padding:24px;}
        .brand{font-weight:700;font-size:14px;color:var(--textMain);display:flex;align-items:center;gap:8px;}
        .brand::before{content:'';width:12px;height:12px;background:var(--primary);border-radius:3px;}
        .catList{flex:1;overflow-y:auto;padding:0 16px 24px;display:flex;flex-direction:column;gap:4px;}
        .catBtn{all:unset;padding:10px 12px;border-radius:6px;cursor:pointer;font-size:14px;font-weight:500;color:var(--textMuted);display:flex;justify-content:space-between;align-items:center;transition:0.15s;width:100%;}
        .catBtn:hover{background:#f9fafb;color:var(--textMain);}
        .catBtn.active{background:var(--accentBg);color:var(--primary);}
        .peakBadge{font-size:11px;background:#f2f4f7;color:var(--textMuted);padding:2px 8px;border-radius:10px;font-weight:600;}
        .catBtn.active .peakBadge{background:var(--primary);color:#fff;}
        .mainContent{flex:1;display:flex;flex-direction:column;padding:32px 48px;gap:32px;overflow-y:auto;}
        .headerArea{display:flex;justify-content:space-between;align-items:flex-start;}
        .headerArea h1{margin:0;font-size:24px;font-weight:600;letter-spacing:-0.02em;}
        .statusText{margin-top:4px;font-size:14px;color:var(--textMuted);}
        .btnGroup{display:flex;gap:12px;}
        .chartContainer{background:var(--panel);border:1px solid var(--border);border-radius:12px;padding:24px;flex:1;display:flex;flex-direction:column;box-shadow:0 1px 2px rgba(16,24,40,.05);}
        .chartHeader{display:flex;justify-content:space-between;margin-bottom:32px;}
        .chartTitleWrap h2{margin:0;font-size:18px;font-weight:600;text-transform:capitalize;}
        .statCard{text-align:right;}
        .statLabel{font-size:12px;font-weight:600;color:var(--textMuted);text-transform:uppercase;letter-spacing:.05em;}
        .statValue{font-size:32px;font-weight:700;color:var(--textMain);}
        .syncBtn{padding:10px 18px;border-radius:8px;font-weight:600;font-size:14px;cursor:pointer;border:1px solid var(--border);transition:.2s;background:#fff;color:#344054;box-shadow:0 1px 2px rgba(16,24,40,.05);}
        .syncBtn:hover{background:#f9fafb;border-color:#d0d5dd;}
        .syncBtn.activeSync{background:var(--primary);color:#fff;border-color:var(--primary);}
        .syncBtn:disabled{opacity:0.6;cursor:not-allowed;}
        .cacheInfo{font-size:11px;color:var(--textMuted);margin-top:4px;}
        /* Full-screen loader overlay — only for cold load */
        .loadOverlay{position:fixed;inset:0;background:rgba(252,252,253,0.85);backdrop-filter:blur(3px);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;z-index:999;opacity:1;transition:opacity .35s ease;}
        .loadOverlay.hide{opacity:0;pointer-events:none;}
        .spinRing{width:40px;height:40px;border:3px solid #e5e7ff;border-top-color:var(--primary);border-radius:50%;animation:spin .75s linear infinite;}
        @keyframes spin{to{transform:rotate(360deg);}}
        .loadLabel{font-size:13px;font-weight:600;color:var(--textMuted);}
        /* Subtle inline refresh dot */
        .refreshDot{display:inline-block;width:7px;height:7px;background:var(--primary);border-radius:50%;margin-right:6px;animation:pulse 1.2s ease-in-out infinite;}
        @keyframes pulse{0%,100%{opacity:1;transform:scale(1);}50%{opacity:.4;transform:scale(.7);}}
    </style>
</head>
<body>
<aside class="sidebar">
    <div class="sidebarHeader"><div class="brand">Cases</div></div>
    <div class="catList" id="categoryBar"></div>
</aside>
<main class="mainContent">
    <header class="headerArea">
        <div>
            <h1 id="mainTitle">Operational Intelligence</h1>
            <div id="status" class="statusText">System ready for synchronization</div>
        </div>
        <div class="btnGroup">
            <button id="syncBtnTickets" class="syncBtn" onclick="fetchData('issues')">Sync Users Issues</button>
            <button id="syncBtnOps" class="syncBtn" onclick="fetchData('ops')">Sync Operations</button>
            <button class="syncBtn" onclick="toggleJsonPanel()">Load JSON</button>
        </div>
        <div class="cacheInfo" id="cacheInfo"></div>
    </header>
    <div id="jsonPanel" style="display:none;background:#fff;border:1px solid var(--border);border-radius:10px;padding:16px;margin-bottom:8px;">
        <div style="font-size:12px;color:var(--textMuted);margin-bottom:8px;font-weight:600;">
            Paste JSON array: <code style="font-size:11px;">[{"date":"…","category":"…","case_count":1}]</code>
        </div>
        <textarea id="jsonInput" rows="6" style="width:100%;font-size:12px;font-family:monospace;border:1px solid var(--border);border-radius:6px;padding:10px;resize:vertical;outline:none;" placeholder='[{"date":"2026-04-25T10:00:00.000Z","category":"CLAIM_RAISED","case_count":12}]'></textarea>
        <div style="display:flex;align-items:center;gap:10px;margin-top:10px;">
            <button class="syncBtn activeSync" onclick="loadJson()">Apply</button>
            <span id="jsonError" style="font-size:12px;color:#d92d20;"></span>
        </div>
    </div>
    <div class="loadOverlay" id="loadOverlay">
        <div class="spinRing"></div>
        <div class="loadLabel" id="loadLabel">Fetching latest data...</div>
    </div>
    <div class="chartContainer">
        <div class="chartHeader">
            <div class="chartTitleWrap">
                <h2 id="chartTitle">Metric Overview</h2>
                <p style="margin:4px 0 0;font-size:14px;color:var(--textMuted);">Historical volume analysis</p>
            </div>
            <div class="statCard">
                <div class="statLabel">Peak Recording</div>
                <div id="peakVal" class="statValue">0</div>
            </div>
        </div>
        <div style="flex:1;position:relative;"><canvas id="mainChart"></canvas></div>
    </div>
</main>
<script>
    const BASE_URL = "${baseUrl}";
    const ENDPOINTS = { issues: "/ops/nugget-ticket-stats", ops: "/ops/ops-action-stats" };
    const AUTH_TOKEN = "${authToken}";
    const CACHE_KEY = function(type){ return 'ops_analytics_' + type; };
    const CACHE_TIME_KEY = function(type){ return 'ops_analytics_time_' + type; };
    let rawData = [], activeChart = null, selectedCat = null;

    function showOverlay(text) {
        const o = document.getElementById('loadOverlay');
        document.getElementById('loadLabel').textContent = text || 'Fetching latest data...';
        o.classList.remove('hide');
        document.getElementById('syncBtnTickets').disabled = true;
        document.getElementById('syncBtnOps').disabled = true;
    }

    function hideOverlay() {
        const o = document.getElementById('loadOverlay');
        o.classList.add('hide');
        document.getElementById('syncBtnTickets').disabled = false;
        document.getElementById('syncBtnOps').disabled = false;
    }

    function setStatusRefreshing(on) {
        const s = document.getElementById('status');
        if (on) {
            const dot = document.createElement('span');
            dot.className = 'refreshDot';
            dot.id = 'refreshDot';
            s.textContent = '';
            s.appendChild(dot);
            s.appendChild(document.createTextNode('Refreshing in background…'));
        } else {
            const existing = document.getElementById('refreshDot');
            if (existing) existing.remove();
        }
    }

    function setCacheInfo(type) {
        const t = localStorage.getItem(CACHE_TIME_KEY(type));
        const el = document.getElementById('cacheInfo');
        el.textContent = t ? 'Cached: ' + new Date(Number(t)).toLocaleString() : '';
    }

    function applyData(type, data) {
        rawData = data;
        document.getElementById('mainTitle').textContent = type === 'issues' ? 'Users Issues' : 'Operational Actions';
        selectedCat = null;
        buildSidebar();
    }

    async function fetchData(type) {
        document.getElementById('syncBtnTickets').classList.toggle('activeSync', type === 'issues');
        document.getElementById('syncBtnOps').classList.toggle('activeSync', type === 'ops');

        const cached = localStorage.getItem(CACHE_KEY(type));
        if (cached) {
            applyData(type, JSON.parse(cached));
            setCacheInfo(type);
            setStatusRefreshing(true);
        } else {
            showOverlay('Fetching latest data…');
        }

        try {
            const res = await fetch(BASE_URL + ENDPOINTS[type], { headers: { Authorization: AUTH_TOKEN } });
            const json = await res.json();
            const src = json.success ? json.data : (Array.isArray(json) ? json : []);
            const mapped = src.map(function(i){ return { date: i.date, category: i.category, count: i.case_count }; });
            localStorage.setItem(CACHE_KEY(type), JSON.stringify(mapped));
            localStorage.setItem(CACHE_TIME_KEY(type), String(Date.now()));
            applyData(type, mapped);
            setCacheInfo(type);
            document.getElementById('status').textContent = 'Updated ' + new Date().toLocaleTimeString();
        } catch(e) {
            document.getElementById('status').textContent = cached ? 'Showing cached data (refresh failed)' : 'Connection failed.';
        } finally {
            hideOverlay();
            setStatusRefreshing(false);
        }
    }

    function buildSidebar() {
        if (!rawData.length) return;
        const cutoff = Date.now() - 72 * 60 * 60 * 1000;
        const recentData = rawData.filter(function(i){ return new Date(i.date).getTime() >= cutoff; });
        const peakMap = {};
        recentData.forEach(function(i){ if (!peakMap[i.category] || i.count > peakMap[i.category]) peakMap[i.category] = i.count; });
        rawData.forEach(function(i){ if (!(i.category in peakMap)) peakMap[i.category] = 0; });
        const sorted = Object.keys(peakMap).sort(function(a,b){ return peakMap[b]-peakMap[a]; });
        selectedCat = selectedCat || sorted[0];
        const bar = document.getElementById('categoryBar');
        while (bar.firstChild) bar.removeChild(bar.firstChild);

        const allBtn = document.createElement('button');
        allBtn.className = 'catBtn' + (selectedCat === '__all__' ? ' active' : '');
        allBtn.dataset.cat = '__all__';
        allBtn.addEventListener('click', function(){ renderAllChart(); });
        const allLabel = document.createElement('span');
        allLabel.textContent = 'All Categories';
        const allBadge = document.createElement('span');
        allBadge.className = 'peakBadge';
        allBadge.textContent = sorted.length;
        allBtn.appendChild(allLabel);
        allBtn.appendChild(allBadge);
        bar.appendChild(allBtn);

        sorted.forEach(function(cat) {
            const btn = document.createElement('button');
            btn.className = 'catBtn' + (cat === selectedCat ? ' active' : '');
            btn.dataset.cat = cat;
            btn.addEventListener('click', function(){ renderChart(cat); });
            const label = document.createElement('span');
            label.textContent = cat.replace(/_/g, ' ');
            const badge = document.createElement('span');
            badge.className = 'peakBadge';
            badge.textContent = peakMap[cat];
            btn.appendChild(label);
            btn.appendChild(badge);
            bar.appendChild(btn);
        });
        if (selectedCat === '__all__') renderAllChart(); else renderChart(selectedCat);
    }

    function renderChart(cat) {
        selectedCat = cat;
        const MONTHS = ['Jan','Feb','March','April','May','June','July','Aug','Sept','Oct','Nov','Dec'];
        const filtered = rawData.filter(function(i){ return i.category === cat; }).sort(function(a,b){ return new Date(a.date)-new Date(b.date); });
        const labels = filtered.map(function(i){
            const d = new Date(i.date);
            const dd = String(d.getDate()).padStart(2,'0');
            const mon = MONTHS[d.getMonth()];
            const yyyy = d.getFullYear();
            const hh = String(d.getHours()).padStart(2,'0');
            const min = String(d.getMinutes()).padStart(2,'0');
            return dd+'-'+mon+'-'+yyyy+' '+hh+':'+min;
        });
        const values = filtered.map(function(i){ return i.count; });
        document.getElementById('chartTitle').textContent = cat.replace(/_/g, ' ');
        document.getElementById('peakVal').textContent = values.length ? Math.max.apply(null, values) : 0;
        document.querySelectorAll('.catBtn').forEach(function(b){ b.classList.toggle('active', b.dataset.cat === cat); });
        if (activeChart) activeChart.destroy();
        const ctx = document.getElementById('mainChart').getContext('2d');
        const grad = ctx.createLinearGradient(0,0,0,400);
        grad.addColorStop(0,'rgba(68,76,231,0.1)');
        grad.addColorStop(1,'rgba(68,76,231,0)');
        activeChart = new Chart(ctx, {
            type: 'line',
            data: { labels: labels, datasets: [{ data: values, borderColor: '#444ce7', borderWidth: 2.5, pointBackgroundColor: '#fff', pointBorderColor: '#444ce7', pointBorderWidth: 2, pointRadius: 4, pointHoverRadius: 6, fill: true, backgroundColor: grad, tension: 0.35 }] },
            options: { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { x: { grid: { display: false }, ticks: { color: '#667085', font: { size: 12 } } }, y: { border: { dash: [4,4] }, grid: { color: '#f2f4f7' }, ticks: { color: '#667085', font: { size: 12 } }, title: { display: true, text: 'Case Count', color: '#667085', font: { size: 12, weight: '600' } } } } }
        });
    }

    function renderAllChart() {
        selectedCat = '__all__';
        const PALETTE = ['#444ce7','#12b76a','#f79009','#e31b54','#7a5af8','#0ba5ec','#ee46bc','#16b364','#dc6803','#6938ef'];
        const MONTHS = ['Jan','Feb','March','April','May','June','July','Aug','Sept','Oct','Nov','Dec'];
        const cats = [...new Set(rawData.map(function(i){ return i.category; }))];
        const allDates = [...new Set(rawData.map(function(i){ return i.date; }))].sort(function(a,b){ return new Date(a)-new Date(b); });
        const labels = allDates.map(function(d){
            const dt = new Date(d);
            const dd = String(dt.getDate()).padStart(2,'0');
            const mon = MONTHS[dt.getMonth()];
            const yyyy = dt.getFullYear();
            const hh = String(dt.getHours()).padStart(2,'0');
            const min = String(dt.getMinutes()).padStart(2,'0');
            return dd+'-'+mon+'-'+yyyy+' '+hh+':'+min;
        });
        const datasets = cats.map(function(cat, idx){
            const color = PALETTE[idx % PALETTE.length];
            const countByDate = {};
            rawData.filter(function(i){ return i.category === cat; }).forEach(function(i){ countByDate[i.date] = i.count; });
            return { label: cat.replace(/_/g,' '), data: allDates.map(function(d){ return countByDate[d] || null; }), borderColor: color, borderWidth: 2, pointBackgroundColor: '#fff', pointBorderColor: color, pointBorderWidth: 2, pointRadius: 3, pointHoverRadius: 5, fill: false, tension: 0.35, spanGaps: false };
        });
        const allCounts = rawData.map(function(i){ return i.count; });
        document.getElementById('chartTitle').textContent = 'All Categories';
        document.getElementById('peakVal').textContent = allCounts.length ? Math.max.apply(null, allCounts) : 0;
        document.querySelectorAll('.catBtn').forEach(function(b){ b.classList.toggle('active', b.dataset.cat === '__all__'); });
        if (activeChart) activeChart.destroy();
        const ctx = document.getElementById('mainChart').getContext('2d');
        activeChart = new Chart(ctx, {
            type: 'line',
            data: { labels: labels, datasets: datasets },
            options: { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: true, position: 'bottom', labels: { boxWidth: 12, font: { size: 11 }, color: '#667085' } } }, scales: { x: { grid: { display: false }, ticks: { color: '#667085', font: { size: 11 } } }, y: { border: { dash: [4,4] }, grid: { color: '#f2f4f7' }, ticks: { color: '#667085', font: { size: 12 } }, title: { display: true, text: 'Case Count', color: '#667085', font: { size: 12, weight: '600' } } } } }
        });
    }

    function toggleJsonPanel() {
        const p = document.getElementById('jsonPanel');
        p.style.display = p.style.display === 'none' ? 'block' : 'none';
        document.getElementById('jsonError').textContent = '';
    }

    function loadJson() {
        const raw = document.getElementById('jsonInput').value.trim();
        const errEl = document.getElementById('jsonError');
        errEl.textContent = '';
        try {
            const parsed = JSON.parse(raw);
            if (!Array.isArray(parsed)) throw new Error('Expected a JSON array');
            const mapped = parsed.map(function(i){ return { date: i.date, category: i.category, count: i.case_count }; });
            if (!mapped.length) throw new Error('Array is empty');
            applyData('manual', mapped);
            document.getElementById('mainTitle').textContent = 'Manual JSON';
            document.getElementById('jsonPanel').style.display = 'none';
        } catch(e) {
            errEl.textContent = 'Invalid JSON: ' + e.message;
        }
    }

    window.addEventListener('load', function() { fetchData('issues'); });
<\/script>
</body>
</html>`;

export default function OpsAnalyticsModal({ onClose }) {
    const iframeRef = useRef(null);
    const blobUrlRef = useRef(null);
    const token = store.getState().user.token || '';

    useEffect(() => {
        const blob = new Blob([buildHtml(token, config.pharmacyService)], { type: 'text/html' });
        blobUrlRef.current = URL.createObjectURL(blob);
        if (iframeRef.current) iframeRef.current.src = blobUrlRef.current;
        return () => { if (blobUrlRef.current) URL.revokeObjectURL(blobUrlRef.current); };
    }, [token]);

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            display: 'flex', flexDirection: 'column',
            background: '#fcfcfd',
        }}>
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 20px', background: '#fff',
                borderBottom: '1px solid #f2f4f7',
                boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                flexShrink: 0,
            }}>
                <span style={{ fontWeight: 700, fontSize: '14px', color: '#101828', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ width: '10px', height: '10px', background: '#444ce7', borderRadius: '3px', display: 'inline-block' }} />
                    Pharmacy Analytics
                </span>
                <button
                    onClick={onClose}
                    style={{
                        padding: '6px 14px', borderRadius: '6px', border: '1px solid #e5e7eb',
                        background: '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: 600,
                        color: '#344054',
                    }}
                >
                    ✕ Close
                </button>
            </div>
            <iframe
                ref={iframeRef}
                style={{ flex: 1, border: 'none', width: '100%' }}
                title="Ops Analytics"
            />
        </div>
    );
}
